module.exports = __webpack_public_path__ + "assets/img/personal-portfolio.f962305e.png";